import type { MenuProps } from "antd";
import type { NavigateFunction } from "react-router-dom";
import {
  IdcardOutlined,
  LogoutOutlined,
  SafetyCertificateOutlined,
  ShoppingOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { globalModel } from "../../global/GlobalModel";

export type ShellUserDropdownMenuOpts = {
  navigate: NavigateFunction;
  /** 「与我相关的空间」弹框 */
  onFollowsClick: () => void;
};

/** 全站统一的顶栏／空间顶栏头像下拉菜单定义 */
export function shellUserDropdownMenu(
  opts: ShellUserDropdownMenuOpts
): MenuProps {
  const { navigate, onFollowsClick } = opts;

  const items: MenuProps["items"] = [
    { key: "profile", label: "个人资料", icon: <IdcardOutlined /> },
    { key: "switch", label: "我的关注", icon: <UnorderedListOutlined /> },
    { key: "orders", label: "我的订单", icon: <ShoppingOutlined /> },
    { key: "benefits", label: "我的权益", icon: <SafetyCertificateOutlined /> },
    { type: "divider" },
    {
      key: "logout",
      label: "退出登录",
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  return {
    items,
    onClick: ({ key }) => {
      if (key === "profile") {
        globalModel.openProfileEditor();
        return;
      }
      if (key === "switch") {
        onFollowsClick();
        return;
      }
      if (key === "orders") {
        navigate("/orders");
        return;
      }
      if (key === "benefits") {
        navigate("/benefits");
        return;
      }
      if (key === "logout") {
        void globalModel.logout().then(() => navigate("/"));
      }
    },
  };
}
